export enum AuthQueryKey {
	Profile = 'auth.profile',
	GetTOTPGenerate = 'auth.getTOTPGenerate',
}

export enum AuthMutationKey {
	Login = 'auth.login',
	Enable2FA = 'auth.enable2FA',
	Disable2FA = 'auth.disable2FA',
	ResetTOTP = 'auth.resetTOTP',
}
